import { Component } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { TypeCreditService } from "../core/service/type-credit.service";
import { TypeCredit } from "../core/model/type-credit";

@Component({
  selector: "app-type-credit",
  templateUrl: "./type-credit.component.html",
  styleUrls: ["./type-credit.component.scss"],
})
export class TypeCreditComponent {
  types: TypeCredit[];

  constructor(
    private _router: Router,
    private _typeCreditService: TypeCreditService
  ) {}

  ngOnInit() {
    this.getListTypeCredit();
  }

  getListTypeCredit() {
    this._typeCreditService.getListTypeCredit().subscribe(
      (data) => {
        this.types = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    this._router.navigate(["/parametrage/type-credit/add-type-credit"]);
  }
}
